import { render, staticRenderFns } from "./wkHonorProductConfig.vue?vue&type=template&id=0480e71e"
import script from "./wkHonorProductConfig.vue?vue&type=script&lang=js"
export * from "./wkHonorProductConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports